import './HomeComponents.css';

const HeroSection = () => {
  const redirectToDeviceStore = (platform: 'android' | 'ios') => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
    const androidLink = "https://play.google.com/store/apps/details?id=com.olitask.app";
    const iosLink = "https://apps.apple.com/us/app/olitask/id6756482938";
    const deepLink = "oliveeb://open";

    if (platform === 'android') {
      if (isAndroid) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = androidLink; }, 1500);
      } else {
        window.open(androidLink, "_blank");
      }
    } else {
      if (isIOS) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = iosLink; }, 1500);
      } else {
        window.open(iosLink, "_blank");
      }
    }
  };

  const copyLink = (link: string, btn: HTMLButtonElement) => {
    navigator.clipboard.writeText(link);
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5"/></svg>';
    btn.style.background = "#16a34a";
    setTimeout(() => {
      btn.innerHTML = originalHTML;
      btn.style.background = "";
    }, 2000);
  };

  const handleCopy = (e: React.MouseEvent, linkValue: string) => {
    e.preventDefault();
    const btn = e.currentTarget as HTMLButtonElement;
    copyLink(linkValue, btn);
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Now available in your area
          </div>
          <img className="hero-brand" src="/assets/logo1.png" alt="Olitask" />
          <p className="hero-description">
            Get things done, faster. Our platform connects you to trusted helpers for anything from daily errands to airport assistance. With just a few taps, you can request help, track progress, and pay securely. At the same time, helpers can earn flexibly by completing tasks. It's simple, fast, and built to make everyday life easier.
          </p>
          <p className="landing-download-label">Download App</p>
          <div className="link-copy-container">
            <div className="link-copy-field">
              <label>Android Link</label>
              <div className="link-input-wrapper">
                <input type="text" id="androidLink" value="https://play.google.com/store/apps/details?id=com.olitask.app" readOnly />
                <button onClick={(e) => handleCopy(e, 'https://play.google.com/store/apps/details?id=com.olitask.app')}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                  </svg>
                </button>
              </div>
            </div>
            <div className="link-copy-field">
              <label>iOS Link</label>
              <div className="link-input-wrapper">
                <input type="text" id="iosLink" value="https://apps.apple.com/us/app/olitask/id6756482938" readOnly />
                <button onClick={(e) => handleCopy(e, 'https://apps.apple.com/us/app/olitask/id6756482938')}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="hero-buttons">
            <button className="btn-download-android" onClick={() => redirectToDeviceStore('android')}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
              </svg>
              Download for Android
            </button>
            <button className="btn-download-ios" onClick={() => redirectToDeviceStore('ios')}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              Download for iOS
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="phone-frame">
            <div className="phone-screen">
              <img src="/assets/asset0.jpg" alt="Olitask app" />
            </div>
          </div>
          <div className="floating-card floating-card-1">
            <div className="floating-icon green">✓</div>
            <div className="floating-text">
              <strong>Task Completed</strong>
              <span>Just now</span>
            </div>
          </div>
          <div className="floating-card floating-card-2">
            <div className="floating-icon blue">★</div>
            <div className="floating-text">
              <strong>4.9 Rating</strong>
              <span>Top helpers</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;